// extracted by mini-css-extract-plugin
export default {"searchInput":"eFO2JOigQo6UawJvf4sE"};